import { motion } from "framer-motion";
import { useSettings } from "@/lib/SettingsContext";

const EASE = [0.16, 1, 0.3, 1];

export default function BeforeAfter() {
  const settings = useSettings();
  const pairs = settings.gallery || [];

  return (
    <section id="gallery" data-testid="before-after-section" className="py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 max-w-2xl"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-[#1B523F]">
            The Difference
          </p>
          <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-[#121A16] sm:text-5xl lg:text-6xl">
            Before <em className="italic text-[#0F382A]">&amp; after.</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {pairs.map((p, i) => (
            <motion.figure
              key={p.label || i}
              data-testid={`gallery-pair-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
              className="group"
            >
              <div className="grid grid-cols-2 overflow-hidden rounded-[1.5rem]">
                <div className="relative">
                  <img
                    src={p.before_url}
                    alt={`${p.label} — before`}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover brightness-[0.6] saturate-[0.3] transition-[filter] duration-700 group-hover:brightness-75"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-[#0B1D16]/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF8F5] backdrop-blur-sm">
                    Before
                  </span>
                </div>
                <div className="relative">
                  <img
                    src={p.after_url}
                    alt={`${p.label} — after`}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 rounded-full bg-[#D4AF37] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#0B1D16]">
                    After
                  </span>
                </div>
              </div>
              <figcaption className="mt-4 font-serif text-xl font-light text-[#121A16]">
                {p.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
